export default function SellerRegister() {
  return (
    <div className="container mt-5 col-md-6">
      <h3>Seller Registration</h3>
      <input className="form-control mb-2" placeholder="Store Name" />
      <input className="form-control mb-2" placeholder="Email" />
      <input className="form-control mb-2" placeholder="Phone" />
      <textarea className="form-control mb-2" placeholder="Address" />
      <button className="btn btn-success">Register</button>
    </div>
  );
}